export default __webpack_public_path__ + "22000800a8e14004e540af35ed750120.svg";